export const APP_VIEW = {
    web: 'web',
    atBat: 'app/atbat',
    ballpark: 'app/ballpark',
};

export const MEDIA_CONFIG_CONTEXT = {
    landing: 'landing',
    search: 'search',
    playback: 'playback',
    app: 'app',
    reel: 'reel',
    home: 'home',
    game: 'game',
};

export const SEARCH_ROUTE = '/';

export const QUERY_PARAMS = {
    query: 'q',
    queryType: 'qt',
    contentPreference: 'cp',
    searchPage: 'p',
    playlistTitle: 'pt',
    feedType: 'ft',
    topicId: 't',
    openFilters: 'of',
    suggestionsModel: 'sm',
};

export const GAME_STATUS = {
    final: 'FINAL',
};

export const GAME_ROUTE = '/game';

export const IMAGE_PLACEHOLDER_SVG = 'data:image/svg+xml;base64,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';

export const CarouselRowType = {
    GENERIC: 'GENERIC',
    FEATURED: 'FEATURED',
    GAMES: 'GAMES',
    CATEGORY_V1: 'CATEGORY_V1',
    CATEGORY_V2: 'CATEGORY_V2',
    PERSONALIZED_V1: 'PERSONALIZED_V1',
    PERSONALIZED_V2: 'PERSONALIZED_V2',
    STORIES: 'STORIES',
};

export const CardType = {
    CONTENT: 'CONTENT',
    HERO: 'HERO',
};
